import {Component} from '@angular/core'
import {LinkService} from '../../i18n/link.service'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {map} from 'rxjs/operators'
import {Observable} from 'rxjs'
import {LayoutService} from '../layout/layout.service'
import {AsyncPipe} from '@angular/common'
import {MinimalFooterComponent} from './minimal/minimal-footer.component'
import {FullFooterComponent} from './full/full-footer.component'

@Component({
  selector: 'bgo-footer',
  templateUrl: './footer.component.html',
  styleUrls: [],
  standalone: true,
  imports: [AsyncPipe, MinimalFooterComponent, FullFooterComponent],
})
export class FooterComponent {
  readonly APPLICATION_ROUTES = PUBLIC_ROUTES

  showProSignUp = true
  showLegalLinks = true
  minimalistFooter$!: Observable<boolean>
  showFooter$: Observable<boolean>
  noFooterMargin$: Observable<boolean>

  constructor(
    readonly linkService: LinkService,
    layoutService: LayoutService,
  ) {
    this.minimalistFooter$ = layoutService.layout$.pipe(map(l => l.showMinimalistFooter ?? false))
    this.noFooterMargin$ = layoutService.layout$.pipe(map(l => l.noFooterMargin ?? false))
    this.showFooter$ = layoutService.layout$.pipe(
      map(l => l.hideFooter ?? false),
      // negate hide boolean here for a cleaner template
      map(bool => !bool),
    )
  }
}
